import React, { useMemo, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { FileText, CheckCircle, Plus, Search, Eye, PenLine, X, Inbox, MapPin, User as UserIcon, Clock, ChevronDown, ChevronRight, ChevronLeft, ChevronsUpDown, Star } from 'lucide-react';
import { DashboardHeader } from '../components/dashboard/DashboardHeader';
interface DashboardContext {
  toggleMobileSidebar: () => void;
}
type ClaimStatus = 'Opened' | 'In Review' | 'Closed';
interface Claim {
  id: string;
  type: string;
  property: string;
  location: string;
  organization: string;
  submittedBy: string;
  onBehalfOf?: string;
  date: string;
  status: ClaimStatus;
  policyNumber: string;
  lossType: string;
  dateOfLoss: string;
  description: string;
  assignedLawyer: string;
  submittedOn: string;
}
const MOCK_CLAIMS: Claim[] = [{
  id: 'CLM-2026-00031',
  type: 'Property disputes',
  property: 'Parkside Towers',
  location: 'Vancouver, BC',
  organization: 'BFL Realty',
  submittedBy: 'Tony Esposito',
  date: '29 Apr, 2026',
  status: 'Opened',
  policyNumber: 'PL-00031',
  lossType: 'Property',
  dateOfLoss: '15 Apr, 2026',
  description: 'Boundary dispute with neighbouring property regarding fence line.',
  assignedLawyer: 'DWF Group',
  submittedOn: '29 Apr, 2026 10:14 AM'
}, {
  id: 'CLM-2026-00024',
  type: 'Bodily harm',
  property: 'KILLARNEY TOWNES -IV-BFL',
  location: 'Calgary, AB',
  organization: 'BFL Realty',
  submittedBy: 'BFL Admin',
  onBehalfOf: 'Maria Chen',
  date: '23 Apr, 2026',
  status: 'Opened',
  policyNumber: 'PL-00024',
  lossType: 'Liability',
  dateOfLoss: '10 Apr, 2026',
  description: 'Slip and fall incident in the lobby.',
  assignedLawyer: 'DWF Group',
  submittedOn: '23 Apr, 2026 09:42 AM'
}, {
  id: 'CLM-2026-00023',
  type: 'Dispute with property owners',
  property: 'TERRACES OF GRIESBACH, P...',
  location: 'Edmonton, AB',
  organization: 'BFL Realty',
  submittedBy: 'BFL Admin',
  onBehalfOf: 'Daniel Roy',
  date: '23 Apr, 2026',
  status: 'Opened',
  policyNumber: 'PL-00023',
  lossType: 'Liability',
  dateOfLoss: '01 Apr, 2026',
  description: 'Owner dispute over common area maintenance.',
  assignedLawyer: 'DWF Group',
  submittedOn: '23 Apr, 2026 11:30 AM'
}, {
  id: 'CLM-2026-00020',
  type: 'Civil defense',
  property: 'Parkside Towers',
  location: 'Vancouver, BC',
  organization: 'BFL Realty',
  submittedBy: 'Skyline Manager',
  date: '08 Apr, 2026',
  status: 'Opened',
  policyNumber: 'PL-00020',
  lossType: 'Liability',
  dateOfLoss: '20 Mar, 2026',
  description: 'Civil claim defense regarding tenant injury.',
  assignedLawyer: 'DWF Group',
  submittedOn: '08 Apr, 2026 02:15 PM'
}, {
  id: 'CLM-2026-00019',
  type: 'Property disputes',
  property: 'Parkside Towers',
  location: 'Vancouver, BC',
  organization: 'BFL Realty',
  submittedBy: 'Skyline Manager',
  onBehalfOf: 'Parkside Owners',
  date: '02 Apr, 2026',
  status: 'Opened',
  policyNumber: 'PL-00019',
  lossType: 'Property',
  dateOfLoss: '15 Mar, 2026',
  description: 'Roof damage dispute with adjoining building.',
  assignedLawyer: 'DWF Group',
  submittedOn: '02 Apr, 2026 04:50 PM'
}, {
  id: 'CLM-2026-00018',
  type: 'Property disputes',
  property: 'Parkside Towers',
  location: 'Vancouver, BC',
  organization: 'BFL Realty',
  submittedBy: 'Skyline Manager',
  date: '23 Mar, 2026',
  status: 'Opened',
  policyNumber: 'PL-00018',
  lossType: 'Property',
  dateOfLoss: '10 Mar, 2026',
  description: 'Parking lot boundary dispute.',
  assignedLawyer: 'DWF Group',
  submittedOn: '23 Mar, 2026 11:20 AM'
}, {
  id: 'CLM-2026-00017',
  type: 'Dispute with property owners',
  property: 'Parkside Towers',
  location: 'Vancouver, BC',
  organization: 'BFL Realty',
  submittedBy: 'BFL Admin',
  onBehalfOf: 'Skyline Manager',
  date: '16 Mar, 2026',
  status: 'Opened',
  policyNumber: 'PL-00017',
  lossType: 'Liability',
  dateOfLoss: '05 Mar, 2026',
  description: 'Dispute over shared utility costs with adjacent owners.',
  assignedLawyer: 'DWF Group',
  submittedOn: '16 Mar, 2026 09:30 AM'
}, {
  id: 'CLM-2026-00016',
  type: 'Dispute with property owners',
  property: 'Parkside Towers',
  location: 'Vancouver, BC',
  organization: 'BFL Realty',
  submittedBy: 'Skyline Manager',
  date: '16 Mar, 2026',
  status: 'Opened',
  policyNumber: 'PL-00001',
  lossType: 'Liability',
  dateOfLoss: '02 Mar, 2026',
  description: 'TEST',
  assignedLawyer: 'DWF Group',
  submittedOn: '16 Mar, 2026 02:59 PM'
}, {
  id: 'CLM-2026-00015',
  type: 'Contract dispute',
  property: 'Parkside Towers',
  location: 'Vancouver, BC',
  organization: 'BFL Realty',
  submittedBy: 'Skyline Manager',
  date: '16 Mar, 2026',
  status: 'Opened',
  policyNumber: 'PL-00015',
  lossType: 'Contractual',
  dateOfLoss: '01 Mar, 2026',
  description: 'Vendor contract dispute over service delivery.',
  assignedLawyer: 'DWF Group',
  submittedOn: '16 Mar, 2026 03:10 PM'
}, {
  id: 'CLM-2026-00014',
  type: 'Civil defense',
  property: 'Parkside Towers',
  location: 'Vancouver, BC',
  organization: 'BFL Realty',
  submittedBy: 'Skyline Manager',
  date: '28 Feb, 2026',
  status: 'Opened',
  policyNumber: 'PL-00014',
  lossType: 'Liability',
  dateOfLoss: '15 Feb, 2026',
  description: 'Defending civil claim from former tenant.',
  assignedLawyer: 'DWF Group',
  submittedOn: '28 Feb, 2026 10:00 AM'
}];
const PROPERTIES = ['Parkside Towers', 'KILLARNEY TOWNES -IV-BFL', 'TERRACES OF GRIESBACH'];
const CLAIM_TYPES = ['Property disputes', 'Bodily harm', 'Civil defense', 'Dispute with property owners', 'Contract dispute'];
const LOSS_TYPES = ['Property', 'Liability', 'Contractual', 'Other'];
function StatusPill({
  status
}: {
  status: ClaimStatus;
}) {
  const styles: Record<ClaimStatus, string> = {
    Opened: 'border-violetBlue/30 bg-violetBlue/5 text-violetBlue',
    'In Review': 'border-amber-300 bg-amber-50 text-amber-700',
    Closed: 'border-disabled bg-aliceBlue text-secondary'
  };
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-md border text-xs font-medium ${styles[status]}`} data-id="element-1426">
      {status}
    </span>;
}
export function Claims() {
  const {
    toggleMobileSidebar
  } = useOutletContext<DashboardContext>() || {
    toggleMobileSidebar: () => {}
  };
  const [claims] = useState<Claim[]>(MOCK_CLAIMS);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState<string>('all');
  const [propertyFilter, setPropertyFilter] = useState<string>('all');
  const [page, setPage] = useState(1);
  const pageSize = 10;
  const [showAddModal, setShowAddModal] = useState(false);
  const [viewingClaim, setViewingClaim] = useState<Claim | null>(null);
  const [editingClaim, setEditingClaim] = useState<Claim | null>(null);
  const filtered = useMemo(() => {
    return claims.filter(c => {
      if (statusFilter !== 'all' && c.status !== statusFilter) return false;
      if (propertyFilter !== 'all' && c.property !== propertyFilter) return false;
      if (search) {
        const q = search.toLowerCase();
        if (!c.id.toLowerCase().includes(q) && !c.type.toLowerCase().includes(q) && !c.property.toLowerCase().includes(q) && !c.submittedBy.toLowerCase().includes(q)) return false;
      }
      return true;
    });
  }, [claims, search, statusFilter, propertyFilter]);
  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
  const pageItems = filtered.slice((page - 1) * pageSize, page * pageSize);
  const stats = {
    total: claims.length + 10,
    opened: claims.filter(c => c.status === 'Opened').length + 8,
    closed: 2
  };
  return <div className="flex flex-col h-full bg-white overflow-y-auto" data-id="element-1427">
      <DashboardHeader onMenuClick={toggleMobileSidebar} showMenuButton data-id="element-1428" />

      <div className="flex-1 px-4 sm:px-6 lg:px-8 py-6 max-w-[1400px] w-full mx-auto" data-id="element-1429">
        <h1 className="text-2xl font-bold text-primary mb-6" data-id="element-1430">Claims</h1>

        {/* Stat Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-1431">
          <StatCard label="Total Claims" value={stats.total} icon={<FileText className="w-5 h-5 text-violetBlue" data-id="element-1433" />} iconBg="bg-violetBlue/10" valueColor="text-violetBlue" data-id="element-1432" />
          <StatCard label="Opened" value={stats.opened} icon={<FileText className="w-5 h-5 text-violetBlue" data-id="element-1435" />} iconBg="bg-aliceBlue" valueColor="text-violetBlue" data-id="element-1434" />
          <StatCard label="Closed" value={stats.closed} icon={<CheckCircle className="w-5 h-5 text-secondary" data-id="element-1437" />} iconBg="bg-aliceBlue" valueColor="text-secondary" data-id="element-1436" />
        </div>

        {/* Filters */}
        <div className="flex flex-col lg:flex-row lg:items-end gap-4 mb-4" data-id="element-1438">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 flex-1" data-id="element-1439">
            <div data-id="element-1440">
              <label className="block text-xs text-secondary mb-1.5" data-id="element-1441">
                Search
              </label>
              <div className="relative" data-id="element-1442">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-disabled" data-id="element-1443" />
                <input type="text" value={search} onChange={e => {
                setSearch(e.target.value);
                setPage(1);
              }} placeholder="Search claims..." className="w-full pl-9 pr-3 py-2 text-sm border border-borderColor rounded-lg focus:outline-none focus:border-violetBlue" data-id="element-1444" />
              </div>
            </div>
            <div data-id="element-1445">
              <label className="block text-xs text-secondary mb-1.5" data-id="element-1446">
                Status
              </label>
              <select value={statusFilter} onChange={e => {
              setStatusFilter(e.target.value);
              setPage(1);
            }} className="w-full px-3 py-2 text-sm border border-borderColor rounded-lg focus:outline-none focus:border-violetBlue bg-white" data-id="element-1447">
                <option value="all" data-id="element-1448">All Statuses</option>
                <option value="Opened" data-id="element-1449">Opened</option>
                <option value="In Review" data-id="element-1450">In Review</option>
                <option value="Closed" data-id="element-1451">Closed</option>
              </select>
            </div>
            <div data-id="element-1452">
              <label className="block text-xs text-secondary mb-1.5" data-id="element-1453">
                Property
              </label>
              <select value={propertyFilter} onChange={e => {
              setPropertyFilter(e.target.value);
              setPage(1);
            }} className="w-full px-3 py-2 text-sm border border-borderColor rounded-lg focus:outline-none focus:border-violetBlue bg-white" data-id="element-1454">
                <option value="all" data-id="element-1455">All Properties</option>
                {PROPERTIES.map(p => <option key={p} value={p} data-id="element-1456">
                    {p}
                  </option>)}
              </select>
            </div>
          </div>
          <button onClick={() => setShowAddModal(true)} className="bg-violetBlue hover:bg-[#6844E8] text-white px-5 py-2.5 rounded-lg font-semibold text-sm flex items-center justify-center gap-2 transition-colors flex-shrink-0" data-id="element-1457">
            <Plus className="w-4 h-4" data-id="element-1458" />
            Add Claim
          </button>
        </div>

        {/* Pagination header */}
        <div className="flex items-center justify-between mb-2" data-id="element-1459">
          <p className="text-xs text-secondary" data-id="element-1460">
            Showing {filtered.length === 0 ? 0 : (page - 1) * pageSize + 1}-
            {Math.min(page * pageSize, filtered.length)} of {filtered.length}
          </p>
          <div className="flex items-center gap-1" data-id="element-1461">
            <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1} className="p-1.5 rounded text-secondary hover:bg-aliceBlue disabled:opacity-30 disabled:cursor-not-allowed" data-id="element-1462">
              <ChevronLeft className="w-4 h-4" data-id="element-1463" />
            </button>
            {Array.from({
            length: totalPages
          }, (_, i) => i + 1).map(p => <button key={p} onClick={() => setPage(p)} className={`w-7 h-7 rounded-full text-xs font-medium ${p === page ? 'bg-primary text-white' : 'text-secondary hover:bg-aliceBlue'}`} data-id="element-1464">
                {p}
              </button>)}
            <button onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages} className="p-1.5 rounded text-secondary hover:bg-aliceBlue disabled:opacity-30 disabled:cursor-not-allowed" data-id="element-1465">
              <ChevronRight className="w-4 h-4" data-id="element-1466" />
            </button>
          </div>
        </div>

        {/* Table */}
        <div className="bg-white border border-borderColor rounded-xl overflow-hidden" data-id="element-1467">
          <div className="overflow-x-auto" data-id="element-1468">
            <table className="w-full text-sm" data-id="element-1469">
              <thead className="bg-aliceBlue/60 border-b border-borderColor" data-id="element-1470">
                <tr data-id="element-1471">
                  {[{
                  label: 'Claim ID',
                  sortable: true
                }, {
                  label: 'Type',
                  sortable: true
                }, {
                  label: 'Property',
                  sortable: false
                }, {
                  label: 'Submitted By',
                  sortable: false
                }, {
                  label: 'Date',
                  sortable: true
                }, {
                  label: 'Status',
                  sortable: true
                }, {
                  label: 'Actions',
                  sortable: false
                }].map(col => <th key={col.label} className="text-left text-xs font-semibold text-secondary px-4 py-3 whitespace-nowrap" data-id="element-1472">
                      <span className="inline-flex items-center gap-1" data-id="element-1473">
                        {col.label}
                        {col.sortable && <ChevronsUpDown className="w-3 h-3 text-disabled" data-id="element-1474" />}
                      </span>
                    </th>)}
                </tr>
              </thead>
              <tbody data-id="element-1475">
                {pageItems.map((claim, idx) => <tr key={claim.id} className={`border-b border-borderColor last:border-0 hover:bg-aliceBlue/40 transition-colors ${idx % 2 === 0 ? 'bg-aliceBlue/30' : 'bg-white'}`} data-id="element-1476">
                    <td className="px-4 py-3 whitespace-nowrap" data-id="element-1477">
                      <button onClick={() => setViewingClaim(claim)} className="text-turquoise font-medium hover:underline" data-id="element-1478">
                        {claim.id}
                      </button>
                    </td>
                    <td className="px-4 py-3 text-primary whitespace-nowrap" data-id="element-1479">
                      {claim.type}
                    </td>
                    <td className="px-4 py-3 text-primary whitespace-nowrap max-w-[200px] truncate" data-id="element-1480">
                      {claim.property}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap" data-id="element-1481">
                      <div className="flex flex-col leading-tight" data-id="element-1482">
                        <span className="text-primary" data-id="element-1483">
                          {claim.submittedBy}
                        </span>
                        {claim.onBehalfOf && <span className="text-xs text-secondary mt-0.5" data-id="element-1484">
                            on behalf of{' '}
                            <span className="font-medium text-primary" data-id="element-1485">
                              {claim.onBehalfOf}
                            </span>
                          </span>}
                      </div>
                    </td>
                    <td className="px-4 py-3 text-primary whitespace-nowrap" data-id="element-1486">
                      {claim.date}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap" data-id="element-1487">
                      <StatusPill status={claim.status} data-id="element-1488" />
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap" data-id="element-1489">
                      <div className="flex items-center gap-2" data-id="element-1490">
                        <button onClick={() => setViewingClaim(claim)} className="p-1.5 text-secondary hover:text-violetBlue hover:bg-aliceBlue rounded transition-colors" title="View" data-id="element-1491">
                          <Eye className="w-4 h-4" data-id="element-1492" />
                        </button>
                        <button onClick={() => setEditingClaim(claim)} className="p-1.5 text-secondary hover:text-violetBlue hover:bg-aliceBlue rounded transition-colors" title="Edit" data-id="element-1493">
                          <PenLine className="w-4 h-4" data-id="element-1494" />
                        </button>
                      </div>
                    </td>
                  </tr>)}
                {pageItems.length === 0 && <tr data-id="element-1495">
                    <td colSpan={7} className="px-4 py-12 text-center text-secondary" data-id="element-1496">
                      No claims match your filters.
                    </td>
                  </tr>}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {showAddModal && <AddClaimModal onClose={() => setShowAddModal(false)} data-id="element-1497" />}
      {viewingClaim && <ClaimDetailsModal claim={viewingClaim} onClose={() => setViewingClaim(null)} onEdit={() => {
      setEditingClaim(viewingClaim);
      setViewingClaim(null);
    }} data-id="element-1498" />}
      {editingClaim && <EditClaimModal claim={editingClaim} onClose={() => setEditingClaim(null)} data-id="element-1499" />}
    </div>;
}
function StatCard({
  label,
  value,
  icon,
  iconBg,
  valueColor
}: {
  label: string;
  value: number;
  icon: React.ReactNode;
  iconBg: string;
  valueColor: string;
}) {
  return <div className="bg-white border border-borderColor rounded-xl p-6 flex items-start justify-between" data-id="element-1500">
      <div data-id="element-1501">
        <p className="text-sm font-semibold text-primary mb-2" data-id="element-1502">{label}</p>
        <p className={`text-4xl font-bold ${valueColor}`} data-id="element-1503">{value}</p>
      </div>
      <div className={`w-10 h-10 rounded-full flex items-center justify-center ${iconBg}`} data-id="element-1504">
        {icon}
      </div>
    </div>;
}
function ModalShell({
  title,
  badge,
  rightBadge,
  onClose,
  children,
  footer
}: {
  title: string;
  badge?: string;
  rightBadge?: React.ReactNode;
  onClose: () => void;
  children: React.ReactNode;
  footer: React.ReactNode;
}) {
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40" data-id="element-1505">
      <div className="bg-white rounded-2xl w-full max-w-3xl max-h-[90vh] flex flex-col shadow-2xl" data-id="element-1506">
        <div className="flex items-center justify-between px-6 py-5 border-b border-borderColor flex-shrink-0" data-id="element-1507">
          <div className="flex items-center gap-3" data-id="element-1508">
            <h2 className="text-xl font-bold text-primary" data-id="element-1509">{title}</h2>
            {badge && <span className="px-2 py-0.5 border border-violetBlue/30 bg-violetBlue/5 text-violetBlue text-xs font-medium rounded-md" data-id="element-1510">
                {badge}
              </span>}
          </div>
          <div className="flex items-center gap-3" data-id="element-1511">
            {rightBadge}
            <button onClick={onClose} className="p-1 text-secondary hover:text-primary hover:bg-aliceBlue rounded transition-colors" data-id="element-1512">
              <X className="w-5 h-5" data-id="element-1513" />
            </button>
          </div>
        </div>
        <div className="flex-1 overflow-y-auto px-6 py-5" data-id="element-1514">{children}</div>
        <div className="px-6 py-4 border-t border-borderColor flex-shrink-0" data-id="element-1515">
          {footer}
        </div>
      </div>
    </div>;
}
function SectionHeader({
  icon,
  title
}: {
  icon?: React.ReactNode;
  title: string;
}) {
  return <div className="border-b border-borderColor pb-2 mb-4" data-id="element-1516">
      <div className="flex items-center gap-2" data-id="element-1517">
        {icon}
        <h3 className="text-base font-bold text-primary" data-id="element-1518">{title}</h3>
      </div>
    </div>;
}
function Field({
  label,
  children
}: {
  label: string;
  children: React.ReactNode;
}) {
  return <div data-id="element-1519">
      <label className="block text-xs text-secondary mb-1.5" data-id="element-1520">{label}</label>
      {children}
    </div>;
}
function ReadField({
  label,
  value
}: {
  label: string;
  value: string;
}) {
  return <div data-id="element-1521">
      <p className="text-xs text-secondary mb-1" data-id="element-1522">{label}:</p>
      <p className="text-sm text-primary font-medium" data-id="element-1523">{value}</p>
    </div>;
}
function UploadDropZone({
  active
}: {
  active?: boolean;
}) {
  return <div className={`border-2 border-dashed rounded-xl p-8 text-center ${active ? 'border-violetBlue/40 bg-aliceBlue/60' : 'border-borderColor bg-aliceBlue/30'}`} data-id="element-1524">
      <Inbox className="w-10 h-10 text-violetBlue mx-auto mb-3" data-id="element-1525" />
      <p className="text-sm text-primary font-medium mb-1" data-id="element-1526">
        Click or drag file to this area to upload
      </p>
      <p className="text-xs text-secondary" data-id="element-1527">
        Supported formats: PDF, DOC, DOCX, XLS, XLSX, JPG, PNG, MP4, MOV, WEBM,
        and other common video types.
      </p>
      <p className="text-xs text-secondary" data-id="element-1528">Max size: 250MB per file.</p>
    </div>;
}
function AddClaimModal({
  onClose
}: {
  onClose: () => void;
}) {
  const [property, setProperty] = useState('');
  return <ModalShell title="Add New Claim" onClose={onClose} footer={<div className="flex items-center justify-end gap-3" data-id="element-1530">
          <button onClick={onClose} className="px-5 py-2 border-2 border-violetBlue text-violetBlue rounded-lg font-medium text-sm hover:bg-aliceBlue transition-colors" data-id="element-1531">
            Cancel
          </button>
          <button onClick={onClose} className="px-5 py-2 bg-violetBlue text-white rounded-lg font-medium text-sm hover:bg-[#6844E8] transition-colors" data-id="element-1532">
            Submit Claim
          </button>
        </div>} data-id="element-1529">
      <div className="space-y-6" data-id="element-1533">
        <div data-id="element-1534">
          <SectionHeader title="Property Information" data-id="element-1535" />
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1536">
            <Field label="Property" data-id="element-1537">
              <select value={property} onChange={e => setProperty(e.target.value)} className="w-full px-3 py-2 text-sm border border-borderColor rounded-lg focus:outline-none focus:border-violetBlue bg-white" data-id="element-1538">
                <option value="" data-id="element-1539">Select property</option>
                {PROPERTIES.map(p => <option key={p} value={p} data-id="element-1540">
                    {p}
                  </option>)}
              </select>
            </Field>
            <Field label="Location" data-id="element-1541">
              <input disabled placeholder="Auto-populated from property" className="w-full px-3 py-2 text-sm border border-borderColor rounded-lg bg-aliceBlue/60 text-disabled placeholder-disabled" data-id="element-1542" />
            </Field>
          </div>
        </div>

        <div data-id="element-1543">
          <SectionHeader title="Claim Details" data-id="element-1544" />
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1545">
            <Field label="Claim Type" data-id="element-1546">
              <select className="w-full px-3 py-2 text-sm border border-borderColor rounded-lg focus:outline-none focus:border-violetBlue bg-white" data-id="element-1547">
                <option value="" data-id="element-1548">Select claim type</option>
                {CLAIM_TYPES.map(t => <option key={t} data-id="element-1549">{t}</option>)}
              </select>
            </Field>
            <Field label="Loss Type" data-id="element-1550">
              <select className="w-full px-3 py-2 text-sm border border-borderColor rounded-lg focus:outline-none focus:border-violetBlue bg-white" data-id="element-1551">
                <option value="" data-id="element-1552">Select loss type</option>
                {LOSS_TYPES.map(t => <option key={t} data-id="element-1553">{t}</option>)}
              </select>
            </Field>
            <Field label="Policy #" data-id="element-1554">
              <input placeholder="Enter policy number" className="w-full px-3 py-2 text-sm border border-borderColor rounded-lg focus:outline-none focus:border-violetBlue" data-id="element-1555" />
            </Field>
            <Field label="Date of Loss" data-id="element-1556">
              <input type="date" className="w-full px-3 py-2 text-sm border border-borderColor rounded-lg focus:outline-none focus:border-violetBlue" data-id="element-1557" />
            </Field>
          </div>
          <div className="mt-4" data-id="element-1558">
            <Field label="Description" data-id="element-1559">
              <textarea rows={3} placeholder="Provide a detailed description of the claim" className="w-full px-3 py-2 text-sm border border-borderColor rounded-lg focus:outline-none focus:border-violetBlue resize-none" data-id="element-1560" />
            </Field>
          </div>
        </div>

        <div data-id="element-1561">
          <SectionHeader title="Lawyer Assignment" data-id="element-1562" />
          <Field label="Select a Lawyer" data-id="element-1563">
            <select disabled={!property} className="w-full px-3 py-2 text-sm border border-borderColor rounded-lg bg-aliceBlue/60 text-disabled cursor-not-allowed" data-id="element-1564">
              <option data-id="element-1565">Select a lawyer</option>
            </select>
          </Field>
          {!property && <p className="text-xs text-secondary mt-2" data-id="element-1566">
              Please select a property first to enable lawyer selection
            </p>}
        </div>

        <div data-id="element-1567">
          <SectionHeader title="Supporting Documents" data-id="element-1568" />
          <UploadDropZone data-id="element-1569" />
        </div>
      </div>
    </ModalShell>;
}
function ClaimDetailsModal({
  claim,
  onClose,
  onEdit
}: {
  claim: Claim;
  onClose: () => void;
  onEdit: () => void;
}) {
  const [updatesOpen, setUpdatesOpen] = useState(false);
  return <ModalShell title="Claim Details" badge={claim.id} rightBadge={<StatusPill status={claim.status} data-id="element-1571" />} onClose={onClose} footer={<div className="flex items-center justify-end gap-3" data-id="element-1572">
          <button onClick={onClose} className="px-5 py-2 border-2 border-violetBlue text-violetBlue rounded-lg font-medium text-sm hover:bg-aliceBlue transition-colors" data-id="element-1573">
            Cancel
          </button>
          <button onClick={onEdit} className="px-5 py-2 bg-violetBlue text-white rounded-lg font-medium text-sm hover:bg-[#6844E8] transition-colors flex items-center gap-2" data-id="element-1574">
            <PenLine className="w-4 h-4" data-id="element-1575" />
            Edit Claim
          </button>
        </div>} data-id="element-1570">
      <div className="space-y-6" data-id="element-1576">
        <div data-id="element-1577">
          <SectionHeader icon={<MapPin className="w-4 h-4 text-primary" data-id="element-1579" />} title="Property Information" data-id="element-1578" />
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-8" data-id="element-1580">
            <ReadField label="Property" value={claim.property} data-id="element-1581" />
            <ReadField label="Location" value={claim.location} data-id="element-1582" />
            <ReadField label="Organization" value={claim.organization} data-id="element-1583" />
          </div>
        </div>

        <div data-id="element-1584">
          <SectionHeader icon={<FileText className="w-4 h-4 text-primary" data-id="element-1586" />} title="Claim Details" data-id="element-1585" />
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-8 mb-4" data-id="element-1587">
            <ReadField label="Claim Type" value={claim.type} data-id="element-1588" />
            <ReadField label="Loss Type" value={claim.lossType} data-id="element-1589" />
            <ReadField label="Policy #" value={claim.policyNumber} data-id="element-1590" />
            <ReadField label="Date of Loss" value={claim.dateOfLoss} data-id="element-1591" />
          </div>
          <p className="text-xs text-secondary mb-1" data-id="element-1592">Description:</p>
          <div className="bg-aliceBlue rounded-lg p-3 text-sm text-primary" data-id="element-1593">
            {claim.description}
          </div>
        </div>

        <div data-id="element-1594">
          <SectionHeader icon={<UserIcon className="w-4 h-4 text-primary" data-id="element-1596" />} title="Assignment & Submission" data-id="element-1595" />
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-8" data-id="element-1597">
            <ReadField label="Assigned Lawyer" value={claim.assignedLawyer} data-id="element-1598" />
            <ReadField label="Submitted By" value={claim.onBehalfOf ? `${claim.submittedBy} on behalf of ${claim.onBehalfOf}` : claim.submittedBy} data-id="element-1599" />
            <ReadField label="Submitted On" value={claim.submittedOn} data-id="element-1600" />
          </div>
        </div>

        <div data-id="element-1601">
          <button onClick={() => setUpdatesOpen(!updatesOpen)} className="flex items-center gap-2 text-primary" data-id="element-1602">
            {updatesOpen ? <ChevronDown className="w-4 h-4" data-id="element-1603" /> : <ChevronRight className="w-4 h-4" data-id="element-1604" />}
            <Clock className="w-4 h-4 text-primary" data-id="element-1605" />
            <span className="font-bold text-base" data-id="element-1606">Claim Updates (1)</span>
          </button>
          {updatesOpen && <div className="mt-4 pl-4" data-id="element-1607">
              <div className="flex items-start gap-3" data-id="element-1608">
                <div className="w-7 h-7 rounded-full bg-turquoise/20 flex items-center justify-center flex-shrink-0" data-id="element-1609">
                  <Plus className="w-4 h-4 text-turquoise" data-id="element-1610" />
                </div>
                <div className="flex-1" data-id="element-1611">
                  <div className="flex items-center gap-2 flex-wrap" data-id="element-1612">
                    <p className="text-sm font-semibold text-primary" data-id="element-1613">
                      Claim {claim.id} submitted
                    </p>
                    <span className="px-2 py-0.5 border border-turquoise/40 bg-turquoise/10 text-turquoise text-[10px] font-semibold rounded" data-id="element-1614">
                      Created
                    </span>
                  </div>
                  <p className="text-xs text-secondary mt-1" data-id="element-1615">
                    {claim.submittedBy} - {claim.submittedOn}
                  </p>
                  <div className="mt-3 bg-aliceBlue rounded-lg p-4 space-y-1.5" data-id="element-1616">
                    {[['Claim ID', claim.id], ['Property', `${claim.property} (${claim.location})`], ['Organization', claim.organization], ['Claim Type', claim.type], ['Loss Type', claim.lossType], ['Policy #', claim.policyNumber], ['Date of Loss', claim.dateOfLoss], ['Lawyer', `${claim.assignedLawyer} (contact.ca@dwfgroup.com)`]].map(([k, v]) => <div key={k} className="flex text-xs" data-id="element-1617">
                        <span className="text-secondary w-28 flex-shrink-0" data-id="element-1618">
                          {k}:
                        </span>
                        <span className="text-primary" data-id="element-1619">{v}</span>
                      </div>)}
                  </div>
                </div>
              </div>
            </div>}
        </div>
      </div>
    </ModalShell>;
}
function EditClaimModal({
  claim,
  onClose
}: {
  claim: Claim;
  onClose: () => void;
}) {
  const [updatesOpen, setUpdatesOpen] = useState(false);
  const [status, setStatus] = useState<ClaimStatus>(claim.status);
  return <ModalShell title="Edit Claim" badge={claim.id} rightBadge={<StatusPill status={status} data-id="element-1621" />} onClose={onClose} footer={<div className="flex items-center justify-between gap-3 flex-wrap" data-id="element-1622">
          <div data-id="element-1623">
            <label className="block text-xs text-secondary mb-1" data-id="element-1624">
              Change Status
            </label>
            <select value={status} onChange={e => setStatus(e.target.value as ClaimStatus)} className="px-3 py-2 text-sm border border-borderColor rounded-lg bg-white focus:outline-none focus:border-violetBlue" data-id="element-1625">
              <option value="Opened" data-id="element-1626">Opened</option>
              <option value="In Review" data-id="element-1627">In Review</option>
              <option value="Closed" data-id="element-1628">Closed</option>
            </select>
          </div>
          <div className="flex items-center gap-3" data-id="element-1629">
            <button onClick={onClose} className="px-5 py-2 border-2 border-violetBlue text-violetBlue rounded-lg font-medium text-sm hover:bg-aliceBlue transition-colors" data-id="element-1630">
              Cancel
            </button>
            <button onClick={onClose} className="px-5 py-2 bg-violetBlue text-white rounded-lg font-medium text-sm hover:bg-[#6844E8] transition-colors" data-id="element-1631">
              Update Claim
            </button>
          </div>
        </div>} data-id="element-1620">
      <div className="space-y-6" data-id="element-1632">
        <div data-id="element-1633">
          <SectionHeader title="Property Information" data-id="element-1634" />
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1635">
            <Field label="Property" data-id="element-1636">
              <select defaultValue={claim.property} className="w-full px-3 py-2 text-sm border border-borderColor rounded-lg focus:outline-none focus:border-violetBlue bg-white" data-id="element-1637">
                {PROPERTIES.map(p => <option key={p} data-id="element-1638">{p}</option>)}
              </select>
            </Field>
            <Field label="Location" data-id="element-1639">
              <input disabled value={claim.location} className="w-full px-3 py-2 text-sm border border-borderColor rounded-lg bg-aliceBlue/60 text-secondary" data-id="element-1640" />
            </Field>
          </div>
        </div>

        <div data-id="element-1641">
          <SectionHeader title="Claim Details" data-id="element-1642" />
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1643">
            <Field label="Claim Type" data-id="element-1644">
              <select defaultValue={claim.type} className="w-full px-3 py-2 text-sm border border-borderColor rounded-lg focus:outline-none focus:border-violetBlue bg-white" data-id="element-1645">
                {CLAIM_TYPES.map(t => <option key={t} data-id="element-1646">{t}</option>)}
              </select>
            </Field>
            <Field label="Loss Type" data-id="element-1647">
              <select defaultValue={claim.lossType} className="w-full px-3 py-2 text-sm border border-borderColor rounded-lg focus:outline-none focus:border-violetBlue bg-white" data-id="element-1648">
                {LOSS_TYPES.map(t => <option key={t} data-id="element-1649">{t}</option>)}
              </select>
            </Field>
            <Field label="Policy #" data-id="element-1650">
              <input defaultValue={claim.policyNumber} className="w-full px-3 py-2 text-sm border border-borderColor rounded-lg focus:outline-none focus:border-violetBlue" data-id="element-1651" />
            </Field>
            <Field label="Date of Loss" data-id="element-1652">
              <input type="date" defaultValue="2026-03-02" className="w-full px-3 py-2 text-sm border border-borderColor rounded-lg focus:outline-none focus:border-violetBlue" data-id="element-1653" />
            </Field>
          </div>
          <div className="mt-4" data-id="element-1654">
            <Field label="Description" data-id="element-1655">
              <textarea rows={3} defaultValue={claim.description} className="w-full px-3 py-2 text-sm border border-borderColor rounded-lg focus:outline-none focus:border-violetBlue resize-none" data-id="element-1656" />
            </Field>
          </div>
        </div>

        <div data-id="element-1657">
          <SectionHeader title="Lawyer Assignment" data-id="element-1658" />
          <Field label="Select a Lawyer" data-id="element-1659">
            <div className="w-full px-3 py-2 text-sm border border-borderColor rounded-lg bg-white flex items-center gap-3" data-id="element-1660">
              <div className="w-8 h-8 rounded-full bg-pink-200 text-pink-800 flex items-center justify-center text-xs font-bold flex-shrink-0" data-id="element-1661">
                dwf
              </div>
              <div className="flex items-center gap-3 flex-1 min-w-0" data-id="element-1662">
                <span className="font-semibold text-primary text-sm" data-id="element-1663">
                  {claim.assignedLawyer}
                </span>
                <span className="text-xs text-secondary" data-id="element-1664">British Columbia</span>
                <div className="flex items-center gap-0.5 ml-auto" data-id="element-1665">
                  {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-3.5 h-3.5 fill-amber-400 text-amber-400" data-id="element-1666" />)}
                </div>
              </div>
              <ChevronDown className="w-4 h-4 text-disabled flex-shrink-0" data-id="element-1667" />
            </div>
          </Field>
        </div>

        <div data-id="element-1668">
          <SectionHeader title="Supporting Documents" data-id="element-1669" />
          <UploadDropZone active data-id="element-1670" />
        </div>

        <div data-id="element-1671">
          <button onClick={() => setUpdatesOpen(!updatesOpen)} className="flex items-center gap-2 text-primary" data-id="element-1672">
            {updatesOpen ? <ChevronDown className="w-4 h-4" data-id="element-1673" /> : <ChevronRight className="w-4 h-4" data-id="element-1674" />}
            <Clock className="w-4 h-4" data-id="element-1675" />
            <span className="font-bold text-base" data-id="element-1676">Claim Updates (1)</span>
          </button>
          {updatesOpen && <div className="mt-4 pl-4" data-id="element-1677">
              <p className="text-xs text-secondary" data-id="element-1678">
                {claim.submittedBy} submitted this claim on {claim.submittedOn}.
              </p>
            </div>}
        </div>
      </div>
    </ModalShell>;
}